import { render, staticRenderFns } from "./PricingChangeLog.html?vue&type=template&id=3763830d&scoped=true&external"
import script from "./PricingChangeLog.js?vue&type=script&lang=js&external"
export * from "./PricingChangeLog.js?vue&type=script&lang=js&external"
import style0 from "./PricingChangeLog.vue?vue&type=style&index=0&id=3763830d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3763830d",
  null
  
)

export default component.exports